import { createEffect, sample } from "effector";
import { paths } from "../../shared/configs/paths";
import { router } from "../../shared/libs/router";
import { notifications } from "@mantine/notifications";
import { campaignsApi } from "../../entities/campaigns/api";

const createFx = createEffect(campaignsApi.createCampaign);

sample({
  clock: createFx.doneData,
  fn: (data) => {
    return {
      to: `${paths.campaignDetails.replace(":id", data.id)}`,
    };
  },
  target: router.navigate,
});

createFx.doneData.watch(() => {
  notifications.show({
    title: "Campaign created",
    message: "Campaign created successfully",
  });
});

export const createCampaignModel = {
  createFx,
};
